import React from 'react';
import './styles.scss';

interface LoadingProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const Loading: React.FC<LoadingProps> = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'loading-sm',
    md: 'loading-md',
    lg: 'loading-lg',
  };

  return (
    <div className={`loading-container ${sizeClasses[size]} ${className}`}>
      <div className="loading-dots">
        <div className="dot dot-1 bg-[#1154BE]"></div>
        <div className="dot dot-2 bg-[#1E8FB5]"></div>
        <div className="dot dot-3 bg-[#2CCBAC]"></div>
      </div>
    </div>
  );
};

export default Loading;
